module.exports = __webpack_public_path__ + "static/media/loader5.06ccb0e9.gif";